import React, { Component } from "react";

// Configs
import { endpoints } from "../../configs";

// Helper
import { isLoggedIn } from "../../lib/helper";

// Components
import PageTitle from "../../components/base/PageTitle";
import AddButton from "../../components/base/AddButton";
import ReduxTable, { ReduxColumn } from "../../components/base/ReduxTable";

export default class Collection extends Component {
  componentDidMount() {
    // Check is logged in user
    isLoggedIn();
  }

  componentDidUpdate() {
    // Check is logged in user
    isLoggedIn();
  }

  render() {
    return (
      <div>
        <PageTitle label="Collections" />
        <AddButton
          label="Add New"
          targetUrl="/collection/add"
          className="pull-right btn btn-secondary"
        />

        <div>
          <ReduxTable
            id="collections"
            apiURL={`${endpoints().collectionAPI}`}
            onRowClick={row => this.props.history.push(`/collection/${row.id}`)}
          >
            <ReduxColumn type="link" isClickable="true" field="name">
              Name
            </ReduxColumn>
            <ReduxColumn field="createdAt">Created At</ReduxColumn>
          </ReduxTable>
        </div>
      </div>
    );
  }
}
